/* global data, serverParams */
/* eslint-disable import/no-relative-packages */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

import { populateUrl } from 'bam-node-baseball-savant/leaderboard/utils/leaderboard-filter-helpers'
import { getFilteredData } from '../utils/bat-tracking-table-helpers'

import initStaticHeaders from '../utils/static-headers'
import concatGroupedHeaders from '../utils/concat-grouped-headers'
import getGroupedHeaders from '../utils/get-grouped-headers'
import getDynamicAggregateFirstHeaders from '../utils/dynamic-aggregate-first-headers'

const showDisclaimer = ['batter', 'batting-team', 'pitcher'].includes(
    serverParams.type
)

const tableDivId = 'frv_table'

function formatIp(outs) {
    if ([null, undefined, '', 0, '0'].includes(outs)) {
        return '--'
    }

    if (outs < 3) {
        return '<1'
        // return `${Math.floor(outs / 3)}.${outs % 3}`
    }

    return Math.round(outs / 3).toLocaleString()
}

const groupHeaders = getGroupedHeaders(serverParams.secondaryGroupBy)

const link = '?stats=statcast-r-fielding-mlb#statcast-fielding-run-value'

const firstHeaders = getDynamicAggregateFirstHeaders(
    serverParams.type,
    serverParams.type === 'fielder' ? link : ''
)

const paTypes = ['batter', 'batting-team']

const headers = [
    ...firstHeaders,

    {
        name: 'Fielding<br />Run Value',
        field: 'total_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        highlightDynamic: true,
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'INF/OF<br />Runs',
        field: 'inf_of_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-left dotted-right`,
        fieldClass: `tr-data align-center border-left dotted-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Range',
        field: 'range_runs',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Arm',
        field: 'arm_runs',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Inf.<br />DP',
        field: 'dp_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Catching<br />Runs',
        field: 'catching_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-left dotted-right`,
        fieldClass: `tr-data align-center border-left dotted-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Framing',
        field: 'framing_runs',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Throwing',
        field: 'throwing_runs',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
    {
        name: 'Blocking',
        field: 'blocking_runs',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'run_value'),
    },
]

if (serverParams.type === 'fielder') {
    headers.push(
        // {
        //     name: 'Total<br />Events',
        //     field: 'tot_plays',
        //     headerClass: `th-component-header align-center th-vertical-bottom border-left border-right`,
        //     fieldClass: `tr-data align-center border-left border-right`,
        //     defaultSortDir: 'desc',
        //     type: 'number',
        //     displayFn: (val) => guff(val, 'pa'),
        // },
        {
            name: 'Total<br />Innings',
            field: 'outs_total',
            headerClass: `th-component-header align-center th-vertical-bottom border-left dotted-right`,
            fieldClass: `tr-data align-center border-left dotted-right`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: 'C',
            field: 'outs_2',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: '1B',
            field: 'outs_3',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: '2B',
            field: 'outs_4',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: '3B',
            field: 'outs_5',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: 'SS',
            field: 'outs_6',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: 'LF',
            field: 'outs_7',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: 'CF',
            field: 'outs_8',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        },
        {
            name: 'RF',
            field: 'outs_9',
            headerClass: `th-component-header align-center th-vertical-bottom border-right`,
            fieldClass: `tr-data align-center border-right`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => formatIp(val),
        }
    )
} else if (
    serverParams.type === 'pitcher' ||
    serverParams.type === 'fielding-team'
) {
    headers.push({
        name: 'Total<br />Innings',
        field: 'outs_2',
        headerClass: `th-component-header align-center th-vertical-bottom border-left border-right`,
        fieldClass: `tr-data align-center border-left border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => formatIp(val),
    })
} else {
    headers.push({
        name: 'Total<br />PA',
        field: 'tot_pa',
        headerClass: `th-component-header align-center th-vertical-bottom border-left border-right`,
        fieldClass: `tr-data align-center border-left border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'pa'),
    })
}

const secondaryHeaders = [
    {
        name: showDisclaimer
            ? `Note: For batter and pitcher tables,<br />
        these values show the fielding run value<br />
        of all <em>fielders</em> while that batter is at the<br />
        plate or that pitcher is on the mound.`
            : '',
        colspan: 4 + groupHeaders.length,
        headerClass: 'th-name-header',
    },
    {
        name: 'Infield / Outfield',
        colspan: 4,
        headerClass:
            'th-title-header border-left border-right th-vertical-bottom',
    },
    {
        name: 'Catching',
        colspan: 4,
        headerClass:
            'th-title-header border-left border-right th-vertical-bottom',
    },
]

if (serverParams.type === 'fielder') {
    secondaryHeaders.push({
        name: 'Innings By Position',
        colspan: 9,
        headerClass:
            'th-title-header border-left border-right th-vertical-bottom',
    })
} else {
    secondaryHeaders.push({
        name: '',
        colspan: 1,
        headerClass: 'th-name-header border-right',
    })
}

function loadTable(data, existingSort = null, existingSortDir = null) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }

    const defaultSort = existingSort || serverParams.sortColumn || 'total_runs'
    const initialSortDirection =
        existingSortDir || serverParams.sortDirection || 'desc'

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        headers: concatGroupedHeaders(headers, groupHeaders),
        secondaryHeaders,
        highlightFalsy: true,
        data,
        hasPinned: true,
        defaultSort,
        initialSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })

    initStaticHeaders(tableDivId, data)
}

const $input = document.querySelector('.table-search')
let currentData = data

if (data && data.length) {
    loadTable(data)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(data, e.target.value)
            loadTable(currentData)
        })
    }
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl({
        position: document.getElementById('ddlPosition')?.value,
        minInnings: document.getElementById('ddlMinInnings')?.value,
        minResults: document.getElementById('ddlMinResults')?.value,
    })
})

const minSelector = document.getElementById('min-innings-selector')
const minResultsSelector = document.getElementById('min-results-selector')
const minSelect = document.getElementById('ddlMinInnings')
const minResultsSelect = document.getElementById('ddlMinResults')

// function handleMinDisplay() {
//     const minShowing = !minSelector.classList.contains('hidden')
//     const minResultsShowing = !minResultsSelector.classList.contains('hidden')
//     const newType = document.getElementById('ddlType').value

//     const isTeamType = ['batting-team', 'fielding-team'].includes(newType)

//     if (!minShowing && !isTeamType) {
//         minSelector.classList.remove('hidden')
//     }
//     if (minShowing && isTeamType) {
//         minSelector.classList.add('hidden')
//     }

//     const hasSplits = getMultiSelectValues(groupByModal).length > 0

//     if (!minResultsShowing && !isTeamType && hasSplits) {
//         minResultsSelector.classList.remove('hidden')
//     }
//     if (minResultsShowing && (isTeamType || !hasSplits)) {
//         minResultsSelector.classList.add('hidden')
//     }
// }

document.getElementById('ddlType').addEventListener('change', () => {
    // handleMinDisplay()
    const newType = document.getElementById('ddlType').value
    const currTitle = minSelector.getAttribute('data-title')

    if (paTypes.includes(newType)) {
        if (currTitle !== 'Min. PA (Tot.)') {
            minSelect.remove(1)
            minResultsSelect.remove(0)
            minSelector.setAttribute('data-title', 'Min. PA (Tot.)')
            minResultsSelector.setAttribute(
                'data-title',
                'Min. PA (w/in Split)'
            )
        }
    } else if (currTitle !== 'Min. Innings (Tot.)') {
        const opt = document.createElement('option')
        const optResult = document.createElement('option')

        opt.value = '0.1'
        opt.text = '0.1'
        optResult.value = '0.1'
        optResult.text = '0.1'

        minSelect.add(opt, 1)
        minResultsSelect.add(optResult, 0)

        minSelector.setAttribute('data-title', 'Min. Innings (Tot.)')
        minResultsSelector.setAttribute(
            'data-title',
            'Min. Innings (w/in Split)'
        )
    }
})

// document
//     .getElementById('group-by-multi-select')
//     .addEventListener('change', () => {
//         handleMinDisplay()
//     })
